// extracted by mini-css-extract-plugin
module.exports = {"Main":"Layouts__Main__35pGc","Layouts":"Layouts__Layouts__1e0uK"};